/**
 * Chargeur de traductions transloco — STATIQUE.
 *
 * BackStage est monolingue : `fr` est la seule langue, et le dictionnaire est
 * connu a la compilation. Le chargeur d'origine (porte de POC-MANAGER) faisait
 * un `HttpClient.get('/assets/i18n/fr.json')`. Trois inconvenients, tous evites
 * ici en important le JSON :
 *
 * 1. **Une requete de plus au demarrage**, sur le chemin critique du premier
 *    rendu — pour 68 ko de libelles qui ne changeront jamais a l'execution.
 * 2. **Un mode degrade visible** : tant que la reponse n'est pas la, transloco
 *    rend les CLES brutes. C'est exactement le symptome deja rencontre avec
 *    `shared.pagination.rangeSummary`.
 * 3. **Un chemin ABSOLU** (`/assets/…`) qui casse tout deploiement sous un
 *    sous-chemin, la ou l'import ne depend d'aucune URL.
 *
 * `resolveJsonModule` est deja actif dans `tsconfig.json`, et le harnais de test
 * (`transloco-testing.ts`) importait deja le fichier de cette facon : les deux
 * chemins partagent desormais la meme source, donc un test ne peut plus passer
 * sur un dictionnaire que la production n'a pas.
 *
 * @module core/i18n
 */
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import fr from '../../../assets/i18n/fr.json';

import type { Translation, TranslocoLoader } from '@jsverse/transloco';
import type { Observable } from 'rxjs';

const TRADUCTIONS: Readonly<Record<string, Translation>> = { fr: fr as Translation };

@Injectable({ providedIn: 'root' })
export class TranslocoStatiqueLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    /* `fr` en repli : `availableLangs` est limite a `['fr']` dans `app.config.ts`,
       donc ce cas ne devrait pas se produire — mais rendre un dictionnaire vide
       afficherait des cles brutes, ce que ce chargeur existe pour eviter. */
    return of(TRADUCTIONS[lang] ?? TRADUCTIONS['fr']);
  }
}
